"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var core_2 = require("@ngx-translate/core");
var ReservationComponent = (function () {
    function ReservationComponent(translate, _ref) {
        var _this = this;
        this.translate = translate;
        this._ref = _ref;
        this._trans = translate.onLangChange.subscribe(function (evt) {
            console.log(evt.translations);
            try {
                _this._ref.detectChanges();
            }
            catch (e) { }
        });
    }
    ReservationComponent.prototype.ngOnDestroy = function () {
        this._trans.unsubscribe();
    };
    return ReservationComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ReservationComponent.prototype, "restaurantName", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], ReservationComponent.prototype, "seats", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], ReservationComponent.prototype, "adults_seats", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], ReservationComponent.prototype, "children_seats", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "courses", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "goDate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "time_label", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "request", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "accept_children", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "pc", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "accept_courses", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "show_request_form", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "noborder", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "is_deposit", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "amount", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "start_at", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "end_at", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "start_time", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ReservationComponent.prototype, "end_time", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "timezone_offset", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "lang", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "selected_table_category", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "addInfo", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], ReservationComponent.prototype, "selected_table_smoking", void 0);
ReservationComponent = __decorate([
    core_1.Component({
        selector: 'trt-reservation',
        template: "\n  <div [ngClass]=\"{pc: pc, noborder: noborder}\">\n    <div *ngIf=\"restaurantName\">\n      <label>{{ 'RESTAURANT_NAME' | translate }}</label>\n      <p class=\"reservation_restaurantName\">{{restaurantName}}</p>\n    </div>\n    <div>\n      <label>{{ 'PARTY_SIZE' | translate }}</label>\n      <p *ngIf=\"!accept_children\" class=\"reservation_seats\">{{seats}}{{ 'PEOPLE' | translate }}</p>\n      <p *ngIf=\"accept_children\">\n        <span class=\"reservation_adults_seats\">{{ 'ADULTS' | translate }} {{adults_seats}}{{ 'PEOPLE' | translate }}</span><span  class=\"reservation_children_seats\">, {{ 'CHILDREN' | translate }} {{children_seats}}{{ 'PEOPLE' | translate }}</span>\n      </p>\n    </div>\n    <div>\n    <label>{{'DATE_TIME' | translate}}</label>\n    <p *ngIf=\"end_at\" class=\"reservation_date_time\">{{ goDate | trtDay:{time: start_time} }} {{ 'IN' | translate }} {{ end_time | trtTime }} {{ 'OUT' | translate }}</p>\n    <p *ngIf=\"!end_at\" class=\"reservation_date_time\">{{ goDate | trtDay:{time: start_time} }} {{ 'IN' | translate }}</p>\n    </div>\n    <div *ngIf=\"is_deposit\">\n    <label>{{ 'PAYMENT.DEPOSIT' | translate }}</label>\n    <p class=\"reservation_deposit\">{{ 'AMOUNT' | translate:{ amount:amount } }}</p>\n    </div>\n    <div *ngIf=\"selected_table_category\">\n      <label>{{ 'TABLE_CAETGORY' | translate }}</label>\n      <p class=\"reservation_table\">{{ 'TABLE_CATEGORIES.'+selected_table_category | translate}}</p>\n    </div>\n    <div *ngIf=\"selected_table_smoking\">\n      <label>{{ 'SELECT_SMOKING' | translate }}</label>\n      <p class=\"reservation_smoking\">{{ 'TABLE_SMOKING.'+selected_table_smoking | translate}}</p>\n    </div>\n    <div *ngIf=\"accept_courses\">\n    <label>{{ 'COURSE' | translate }}</label>\n    <div>\n      <p *ngIf=\"courses.length == 0\">{{'NO_COURSES' | translate}}</p>\n      <p *ngFor=\"let course of courses\" class=\"reservation_courses\">{{course.name}} {{ 'RESERVE_INFO.IN_TAX' | translate:{price:course.price, seats:course.seats} }}</p>\n    </div>\n    </div>\n    <div *ngIf=\"addInfo\">\n      <label>{{ 'ADD_INFO' | translate }}</label>\n      <p  class=\"reservation_add_info\">{{addInfo}}</p>\n    </div>\n    <div *ngIf=\"show_request_form\">\n    <label>{{ 'REQUEST' | translate }}</label>\n    <div><p innerHtml=\"{{request | trtBr}}\"  class=\"reservation_request\"></p></div>\n    </div>\n  </div>\n  ",
        styles: [require('./reservation.component.css')]
    }),
    __metadata("design:paramtypes", [core_2.TranslateService, core_1.ChangeDetectorRef])
], ReservationComponent);
exports.ReservationComponent = ReservationComponent;
